import * as React from 'react'

function SvgMicOff(props, svgRef) {
  return (
    <svg viewBox="0 0 32 32" fill="#204566" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.916 1.413a5.2 5.2 0 018.284 4.19m0 .002v6.94a1.3 1.3 0 11-2.6 0V5.604a2.6 2.6 0 00-5.148-.52 1.3 1.3 0 11-2.548-.518 5.2 5.2 0 012.012-3.152M.78.785a1.3 1.3 0 011.838 0l20.525 20.524a1.304 1.304 0 01.486.486l7.59 7.59a1.3 1.3 0 01-1.84 1.838l-6.967-6.968a10.495 10.495 0 01-5.113 2.118v2.63h3.9a1.3 1.3 0 010 2.6H10.8a1.3 1.3 0 010-2.6h3.9v-2.622c-.906-.11-1.803-.34-2.666-.696-3.881-1.601-6.463-5.488-6.434-9.686v-2.595a1.3 1.3 0 012.6 0v2.61c-.023 3.14 1.923 6.07 4.825 7.267a7.676 7.676 0 002.624.57 1.303 1.303 0 01.691-.002 7.932 7.932 0 004.215-1.451L18.64 20.48a5.2 5.2 0 01-7.839-4.476v-3.363L.78 2.623a1.3 1.3 0 010-1.838zM13.4 15.242v.76a2.6 2.6 0 003.27 2.51l-3.27-3.27zm11.7-3.138a1.3 1.3 0 011.3 1.3c0 .27.005.556.01.855.02 1.101.042 2.372-.173 3.573a1.3 1.3 0 11-2.56-.459c.167-.927.152-1.852.134-2.906a63.51 63.51 0 01-.011-1.063 1.3 1.3 0 011.3-1.3z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgMicOff)
export default ForwardRef
